import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../../auth'

const ProposalsEstimationsListPage = () =>
    import('@/pmd/pages/payments/ProposalsEstimatesList.vue')

export const DocumentsContractsListRoute: RouteConfig[] = [
    {
        path: 'payments/proposals-estimates',
        name: 'proposals-estimates',
        component: ProposalsEstimationsListPage,
        beforeEnter: requireAuthAndLocation,
        children: [
            {
            path: 'settings',
            name: 'proposals-estimates-settings',
            component: ProposalsEstimationsListPage,
            beforeEnter: requireAuthAndLocation,
            },
        ],
    },
]
